<template>
  <div :class="{ formValidated: validateFormCalled }" class="forestShopFix">
    <ValidationObserver ref="formValidation" tag="form" v-slot="{ invalid }">
      <h2>1. Välj kategori</h2>
      <div class="flex flex-col flex-wrap sm:flex-row justify-center items-center">
        <button
          type="button"
          v-for="greeting in greetingsToShow()"
          :key="greeting.value"
          class="btn w-40 hover:bg-white text-smaller md:text-base mt-4 sm:ml-4 sm:mt-0"
          :class="activeGreetingClass(greeting.value)"
          @click="setCurrentGreeting(greeting)"
        >
          {{greeting.label}}
        </button>
        <div class="break"></div>
        <div class="mt-4 w-80 text-center" :class="flipped ? 'flip-container flipped': 'flip-container'">
          <div class="flipper">
            <div class="front">
              <button
                type="button"
                class="btn text-smaller normal-case italic md:text-base sm:ml-4 mt-0"
                :class="activeGreetingClass('Egen')"
                @click="flipped=true"
                >
                {{ customGreeting || "Skriv egen" }}
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" class="w-4 h-4 inline mb-1">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z"></path>
                </svg>
              </button>
            </div>
            <div class="back">
              <ValidationProvider v-slot="{ valid, classes, errors, ariaMsg }" name="Hälsning" rules="max:30|min:2">
                <div class="flex validation relative justify-center" style="white-space: nowrap;">
                  <input
                    style="-webkit-backface-visibility: hidden;"
                    v-model="customGreeting"
                    id="Hälsning"
                    class="text-input rounded focus:outline-none px-1 md:px-2 w-48 md:w-64"
                    type="text"
                    :maxlength="30"
                    placeholder="Egen hälsning">
                  <button
                    style="-webkit-backface-visibility: hidden;"
                    type="button"
                    :disabled="!customGreeting || customGreeting.length < 3 || customGreeting.length > 30"
                    @click.stop.prevent="setCustomGreeting"
                    class="bg-cta text-gray-800 ml-2 px-3 text-smaller md:text-base hover:bg-cta-active md:py-2 md:px-4 rounded">OK</button>
                </div>
                <span v-bind="ariaMsg" class="text-error">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>
        </div>
      </div>
      <transition v-on:after-enter="scrollToStep2" name="fade">
        <div id="step2" v-if="currentGreeting && (currentGreeting.value || customGreeting)">
          <h2>2. Välj motiv</h2>
          <div class="flex justify-center flex-wrap">
            <div
              v-for="product in productsMatchingGreeting(currentGreeting)"
              :key="product.id"
              class="cursor-pointer border-2 border-transparent hover:border-nagreen rounded w-32 md:w-40 lg:w-48 mr-0 lg:mr-4 mb-4 p-2"
              :class="activeProductClass(product.id)"
              @click="selectProduct(product)"
            >
              <div class="overflow-hidden rounded shadow">
                <img
                  class="h-24 lg:h-32 w-32 md:w-40 lg:w-48 object-cover"
                  :src="product.image_url"
                >
                <div class="bg-gray-100 py-2 px-2 md:px-3 truncate">
                  <h5 class="mt-0">{{ product.post_title }}</h5>
                  <div class="text-gray-500 truncate">
                    <span v-if="product.price_unit != 'sum'" class="text-smaller text-textgreen">{{ product.price }} kr
                      <span class="text-gray-500">/ {{ product.singular }}</span>
                    </span>
                    <span v-else class="text-smaller text-gray-500">Valfritt belopp</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
      <transition v-on:after-enter="scrollToDetails" name="fade">
        <div id="details" class="max-w-md mx-auto" v-if="!isEmpty(currentProduct)">
          <h2>3. Fyll i detaljer</h2>
          <div class="mt-4">
            <TextInput v-model="to" name="Till" type="text" :customMessages="{ 'required': 'Ange vem gåvan är till' }" rules="required" placeholder="Till"></TextInput>
          </div>
          <div class="mt-4">
            <ValidationProvider :skipIfEmpty="false" :customMessages="{'required': 'Skriv ett personligt meddelande'}" v-slot="{ classes, errors, ariaMsg, ariaInput }" name="Meddelande" rules="required">
              <label class="relative block text-gray-700 text-smaller font-bold mb-2" for="message">
                Personligt meddelande <span class="absolute right-0 text-gray-500 font-normal">{{messagePercentage}}% av max</span>
              </label>
              <div class="relative validation" :class="classes">
                <textarea v-bind="ariaInput" v-model="message" rows="4" class="resize-none appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight outline-none" :class="{ nonEmpty: message && message.length }" placeholder="Personligt meddelande">
                </textarea>
                <svg class="validation absolute text-green-500 inset-y-0 right-0 mr-3 mt-3 fill-current" xmlns="http://www.w3.org/2000/svg" width="24" height="24" style="-ms-transform:rotate(360deg);-webkit-transform:rotate(360deg)" transform="rotate(360)"><path d="M10 15.586l-3.293-3.293-1.414 1.414L10 18.414l9.707-9.707-1.414-1.414z" fill="currentColor"/><path fill="rgba(0, 0, 0, 0)" d="M0 0h24v24H0z"/></svg>
                <span v-bind="ariaMsg" class="text-error">{{ errors[0] }}</span>
              </div>
            </ValidationProvider>
          </div>
          <div key="per_unit" v-if="currentProduct.price_unit != 'sum'" class="mt-4">
            <label class="block text-gray-700 text-smaller font-bold mb-2" for="vue-slider">
              Hur många {{ currentProduct.plural }} vill du ska bevaras?
            </label>
            <div class="flex justify-between items-center">
              <vue-slider
                class="mx-2 flex-1"
                v-model="numberOfTrees"
                :min="1"
                :max="10"
                :interval="1"
                :marks="numTreesMarks"
                :process='false'
                :dotStyle="{ border: '2px solid #4a5568' }"
                :tooltipStyle="{ backgroundColor: '#4a5568' }"
              />
            </div>
          </div>
          <div v-else key="sum" class="mt-4">
            <TextInput v-model="sum" name="Belopp" type="tel" :customMessages="{ 'required': 'Ange belopp du vill ge' }" :rules="{required: true, minValue: testmode ? 5 : 50 }" placeholder="Belopp"></TextInput>
          </div>
          <div class="mt-10">
            <div class="flex justify-end">
              <span v-if="currentProduct.price_unit != 'sum'">{{ numberOfTrees }} <span class="text-smaller text-gray-600">&#x00D7;</span> {{ currentProduct.price_unit != 'sum' ? currentProduct.price : sum}} kr</span>
            </div>
            <div class="mt-2 flex justify-between items-center">
              <span class="text-lg">Summa:</span>
              <span class="border-t-2 border-gray-400 w-24 text-right text-xl">{{ (currentProduct.price_unit != 'sum' ? parseInt(currentProduct.price) : sum) * parseInt(numberOfTrees) }}<span class="ml-2">kr</span></span>
            </div>
            <div class="flex flex-col items-end mt-4">
              <span v-if="error" class="text-error block bg-red-100 rounded py-2 mt-2 px-2">{{ error }}</span>
              <div class="flex text-nagreen items-center">
                <label class="flex items-center" for="saveInCart">
                  <svg class="fill-current mr-2 w-3 h-3" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M4 2h16l-3 9H4a1 1 0 1 0 0 2h13v2H4a3 3 0 0 1 0-6h.33L3 5 2 2H0V0h3a1 1 0 0 1 1 1v1zm1 18a2 2 0 1 1 0-4 2 2 0 0 1 0 4zm10 0a2 2 0 1 1 0-4 2 2 0 0 1 0 4z"/></svg>
                  Spara i kundvagn
                </label>
                <input type="checkbox" class="ml-2 na-checkbox appearance-none text-nagreen" id="saveInCart" v-model="saveInCart">
              </div>
              <div class="flex relative">
                <span v-if="invalid" class="absolute w-32 h-12 mt-2 z-50 right-0 top-0" @click="validateForm"></span>
                <button type="button" @click.stop="showPreviewModal" class="mt-2 btn btn-secondary normal-case btn-border">Förhandsgranska</button>
                <button type="button" @click="placeOrder" :disabled="invalid || loading" class="mt-2 btn btn-primary normal-case ml-4 px-6 md:px-12">{{ saveInCart ? 'Spara' : 'Beställ' }}</button>
              </div>
            </div>
          </div>
        </div>
      </transition>
      <transition name="overlay-fade">
        <div v-if="showPreview" @click="closePreviewModal" class="modal fixed w-full h-full top-0 left-0 flex items-center justify-center z-50">
          <div class="modal-overlay absolute w-full h-full bg-gray-900 opacity-50"></div>
          <div class="bg-white w-11/12 max-w-lg mx-auto max-h-screen relative rounded shadow-lg overflow-hidden">
            <div v-if="loading" class="absolute" style="top: 50%; left: 50%">
              <svg xmlns="http://www.w3.org/2000/svg" style="margin:auto;" width="50" height="50" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid" display="block"><rect x="47" y="27" rx="3" ry="3" width="6" height="6"><animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1s" begin="-0.9166666666666666s" repeatCount="indefinite"/></rect><rect x="47" y="27" rx="3" ry="3" width="6" height="6" transform="rotate(30 50 50)"><animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1s" begin="-0.8333333333333334s" repeatCount="indefinite"/></rect><rect x="47" y="27" rx="3" ry="3" width="6" height="6" transform="rotate(60 50 50)"><animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1s" begin="-0.75s" repeatCount="indefinite"/></rect><rect x="47" y="27" rx="3" ry="3" width="6" height="6" transform="rotate(90 50 50)"><animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1s" begin="-0.6666666666666666s" repeatCount="indefinite"/></rect><rect x="47" y="27" rx="3" ry="3" width="6" height="6" transform="rotate(120 50 50)"><animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1s" begin="-0.5833333333333334s" repeatCount="indefinite"/></rect><rect x="47" y="27" rx="3" ry="3" width="6" height="6" transform="rotate(150 50 50)"><animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1s" begin="-0.5s" repeatCount="indefinite"/></rect><rect x="47" y="27" rx="3" ry="3" width="6" height="6" transform="rotate(180 50 50)"><animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1s" begin="-0.4166666666666667s" repeatCount="indefinite"/></rect><rect x="47" y="27" rx="3" ry="3" width="6" height="6" transform="rotate(210 50 50)"><animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1s" begin="-0.3333333333333333s" repeatCount="indefinite"/></rect><rect x="47" y="27" rx="3" ry="3" width="6" height="6" transform="rotate(240 50 50)"><animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1s" begin="-0.25s" repeatCount="indefinite"/></rect><rect x="47" y="27" rx="3" ry="3" width="6" height="6" transform="rotate(270 50 50)"><animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1s" begin="-0.16666666666666666s" repeatCount="indefinite"/></rect><rect x="47" y="27" rx="3" ry="3" width="6" height="6" transform="rotate(300 50 50)"><animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1s" begin="-0.08333333333333333s" repeatCount="indefinite"/></rect><rect x="47" y="27" rx="3" ry="3" width="6" height="6" transform="rotate(330 50 50)"><animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1s" begin="0s" repeatCount="indefinite"/></rect></svg>
            </div>
            <div class="modal-container relative h-0">
              <img class="absolute h-full w-full bottom-0" :src="previewImg">
            </div>
          </div>
        </div>
      </transition>
    </ValidationObserver>
    <modal transition="overlay-fade"
      :clickToClose="false"
      :delay="100"
      :adaptive="true"
      name="checkoutModal"
      height="auto"
      :scrollable="true"
      :maxWidth="672"
      classes="mt-2 mb-8i"
      width="100%">
      <checkout
        @close="closeCheckoutModal"
        @success="showThankYouModal"
        @generatePreviewFor="generatePreviewFor"
        :shoppingCart="shoppingCart"
        :preview="previewImg"
        :testmode="testmode">
      </checkout>
    </modal>
    <ThankYouModal
      :show="showThankYou"
      :print="print"
      :assets="assets"
      :orderId="orderId"
      :pdf="pdf"
      title="Tack för din gåva!"
      button1Title="Till startsidan"
      :button1OnClick="goHome"
      button2Title="Fortsätt handla"
      :button2OnClick="reload">
    </ThankYouModal>
  </div>
</template>

<script>
  import isEmpty from 'lodash/isEmpty'
  import last from 'lodash/last'
  import isEqual from 'lodash/isEqual'
  import getISOWeek from 'date-fns/getISOWeek'
  import VueScrollTo from 'vue-scrollto'
  import VueSlider from 'vue-slider-component'
  import 'vue-slider-component/theme/antd.css'
  import Checkout from './Checkout.vue'
  import { ValidationProvider, ValidationObserver } from 'vee-validate'
  import TextInput from './TextInput.vue'
  import axios from 'axios'
  import ThankYouModal from './ThankYouModal.vue'

  export default {
    components: {
      VueSlider,
      Checkout,
      TextInput,
      ValidationProvider, 
      ValidationObserver,
      ThankYouModal,
    },
    data() {
      return {
        addedToLocalCart: false,
        showPreview: false,
        showThankYou: false,
        currentProduct: {},
        currentGreeting: null,
        customGreeting: null,
        to: '',
        rawMessage: '',
        messagePercentage: 0,
        loading: false,
        error: undefined,
        email: undefined,
        orderId: undefined,
        pdf: undefined,
        print: undefined,
        iframeReloaded: 0,
        validateFormCalled: false,
        preview: {},
        previewImg: undefined,
        currentLoadedPreview: undefined,
        sum: undefined,
        testmode: false,
        numberOfTrees: 1,
        shoppingCart: [],
        saveInCart: false,
        flipped: false,
      }
    },

    mounted() {
      this.addedToLocalCart = false
      this.$root.$on('showShoppingCart', () => {
        this.showCheckoutModal()
      })
      this.shoppingCart = []
      if (localStorage && localStorage.getItem('shoppingCart')) {
        try {
          this.shoppingCart = JSON.parse(localStorage.getItem('shoppingCart'))
          this.$root.$emit('addToShoppingCart', this.shoppingCart.length)
        } catch(e) {
          localStorage.removeItem('shoppingCart')
        }
      }
    },

    computed: {
      shoppingCartEmpty() {
        return !this.shoppingCart || this.shoppingCart.length == 0
      },
      previewPostData() {
        return {
          postId: this.currentProduct.id,
          greeting: this.currentGreeting.pdfLabel || this.currentGreeting.label || this.customGreeting,
          to: this.to,
          message: encodeURIComponent(this.message),
          numTrees: this.numberOfTrees,
        }
      },
      message: {
        get() {
          return this.rawMessage
        },
        set(value) {
          let aproxNumRows = (value.match(/\n/g) || []).length + value.split("\n").filter(r => r.length > 50).length
          if (aproxNumRows <= 6) {
            this.messagePercentage = Math.round(aproxNumRows * 14.3 +
              last((value || '').split("\n")).length/50 * 14.3)
            this.rawMessage = value
          }
        }
      },
    },

    created() {
      let uri = window.location.search.substring(1)
      let params = new URLSearchParams(uri)
      this.testmode = params.has('test')
    },

    methods: {
      isEmpty,
      selectProduct(product) {
        this.currentProduct = product
        this.sum = this.currentProduct.price
        this.numberOfTrees = 1
      },
      reload() {
        location.reload()
      },
      isNumeric (num){
        return !isNaN(num)
      },
      greetingsToShow() {
        const currentWeek = getISOWeek(new Date());
        return this.greetings.filter(greeting => {
          if (!this.productsMatchingGreeting(greeting).length) {
            return false
          }
          if (!greeting['weeksToShow']) {
            return true
          }
          const weeks = greeting['weeksToShow'].split('-')
          if (this.isNumeric(weeks[0]) && this.isNumeric(weeks[1])) {
            return currentWeek >= weeks[0] && currentWeek <= weeks[1]
          }
        });
      },
      goHome() {
        window.location.href = '/'
      },
      showThankYouModal(e) {
        localStorage.removeItem('shoppingCart')
        this.$root.$emit('emptyShoppingCart')
        this.shoppingCart = []
        this.$modal.hide('checkoutModal');
        this.showThankYou = true
        this.email = e.email
        this.print = e.print
        this.orderId = e.orderId
        this.pdf = e.pdf
      },
      setCustomGreeting() {
        this.flipped = false
        const self = this
        setTimeout(() => {
          self.currentGreeting = { value: 'Egen', label: self.customGreeting }
        }, 600)
      },
      setCurrentGreeting(greeting) {
        if (this.currentGreeting && greeting.value == this.currentGreeting.value) return

        this.currentGreeting = greeting
        this.currentProduct = {}
      },
      productsMatchingGreeting(greeting)  {
        return this.products.filter((p) => {
          if (greeting.value == 'Egen') {
            return true
          }
          const greetings = p.greeting.map(g => g['value'])
          return greetings.includes(greeting.value)
        })
      },
      activeGreetingClass(greetingValue) {
        if (!this.currentGreeting) return ['btn-border']

        return this.currentGreeting.value == greetingValue ?
          [ 'bg-nagreen-light', 'text-white', 'hover:bg-nagreen-light' ] :
          [ 'btn-border', 'opacity-25' ]
      },
      activeProductClass(productId) {
        if (isEmpty(this.currentProduct)) return 'border-transparent'

        return this.currentProduct.id === productId ?
          [ 'border-nagreen' ] : 
          [ 'border-transparent', 'opacity-25' ]
      },
      scrollToStep2() {
        VueScrollTo.scrollTo('#step2', 500, { offset: -66 })
      },
      scrollToDetails() {
        VueScrollTo.scrollTo('#details', 500, { offset: -66 })
      },
      numTreesMarks(v) {
        return [1, 5, 10, 15, 20].includes(v) ? true : ({
          label: ''
        })
      },
      previewImgSrc(imageData) {
        return `data:image/jpeg;base64,${imageData}`
      },
      async showPreviewModal() {
        this.showPreview = true
        this.loading = true
        document.body.classList.add('modal-block-scroll')
        await this.generatePreview()
        this.loading = false
      },
      async generatePreviewFor(item) {
        this.previewImg = undefined
        const { data } = await axios.post('/wp-json/naturarvet/v1/pdfPreview',
          {
            postId: item.productId,
            greeting: item.greeting,
            to: item.to,
            message: encodeURIComponent(item.message),
            numTrees: item.numTrees,
          }
        )
        this.previewImg = this.previewImgSrc(data.content)
      },
      async generatePreview() {
        if (isEqual(this.currentLoadedPreview, this.previewPostData)) {
          return
        }
        this.previewImg = undefined
        const { data } = await axios.post('/wp-json/naturarvet/v1/pdfPreview', this.previewPostData)
        this.previewImg = this.previewImgSrc(data.content)
        this.currentLoadedPreview = this.previewPostData
      },
      closePreviewModal(event) {
        if (!this.showPreview) {
          return
        }
        this.showPreview = false
        this.loading = false
        document.body.classList.remove('modal-block-scroll')
        event.preventDefault()
      },
      placeOrder() {
        if (!this.addedToLocalCart) {
          this.addToLocalCart()
          this.addedToLocalCart = true
        }
        if (this.saveInCart) {
          this.updateGlobalCart()
          if (this.isOnMobile()) {
            window.scrollTo(0, 0); 
            this.reset()
          } else {
            setTimeout(this.reset.bind(this), 500)
          }
        } else {
          this.showCheckoutModal()
        }
      },
      isOnMobile() {
        const ua = navigator.userAgent||navigator.vendor||window.opera
        if(/(android|bb\d+|meego).+mobile|blackberry|iemobile|ip(hone|od)|kindle|mobile.+firefox|opera m(ob|in)i|symbian|windows ce/i.test(ua)) {
          return true
        }
        return false
      },
      addToLocalCart() {
        this.shoppingCart.push({
          productId: this.currentProduct.id,
          title: this.currentProduct.post_title,
          price: this.currentProduct.price_unit != 'sum' ? this.currentProduct.price : parseInt(this.sum),
          priceUnit: this.currentProduct.price_unit,
          greeting: this.currentGreeting.pdfLabel || this.currentGreeting.label || this.customGreeting,
          to: this.to,
          message: this.message,
          numTrees: this.numberOfTrees,
        })
      },
      reset() {
        this.addedToLocalCart = false
        this.currentGreeting = null
        this.customGreeting = null
        this.currentProduct = {}
        this.to = null
        this.rawMessage = null
        this.numberOfTrees = 1
        this.saveInCart = false
      },
      updateGlobalCart() {
        localStorage.setItem('shoppingCart', JSON.stringify(this.shoppingCart))
        this.$root.$emit('addToShoppingCart')
      },
      showCheckoutModal() {
        if (this.message && this.to) {
          this.generatePreview()
        } else if (this.shoppingCart && this.shoppingCart.length == 1) {
          this.generatePreviewFor(this.shoppingCart[0])
        }
        document.body.classList.add('modal-block-scroll')
        this.$modal.show('checkoutModal');
      },
      closeCheckoutModal() {
        document.body.classList.remove('modal-block-scroll')
        this.$modal.hide('checkoutModal');
        // Ta bara bort ur local shopping cart om vi inte gjort reset kolla
        // t.ex. att en produkt är vald
        if (this.currentGreeting) {
          this.shoppingCart.pop()
          this.addedToLocalCart = false
        }
      },
      async validateForm(e) {
        this.validateFormCalled = true
        const { valid } = await this.$refs.formValidation.validate(e)
        if (!valid) {
          VueScrollTo.scrollTo('#details')
          return false
        }
        return true
      },
    },

    props: {
      'products': Array,
      'assets': String,
      'greetings': Array,
    },
  }
</script>

<style lang="scss" scoped>
  .fade-enter-active {
    transition: opacity .5s;
  }
  .fade-enter, .fade-leave-to {
    opacity: 0;
  }
  .overlay-fade-enter-active,
  .overlay-fade-leave-active {
    transition: all 0.2s;
  }

  .overlay-fade-enter,
  .overlay-fade-leave-active {
    opacity: 0;
  }
  .modal-container {
    padding-bottom:140%;
  }
  .break {
    flex-basis: 100%;
    height: 0;
  }
  .flip-container {
    perspective: 1000;
    -webkit-perspective:1000;
  }
  .flip-container {
    min-height: 30px;
  }
  .flipper {
    position: relative;
  }
  .front, .back {
    // backface-visibility: hidden;
    // transition: 0.1s;
    // // transform-style: preserve-3d;
    // transform-style: flat;
    // -webkit-backface-visibility: hidden;
    // // -webkit-transform: translate3d(0,0,0);
    // -webkit-transform:none;
    // transform:none;
    // // -webkit-transform-style: preserve-3d;
    // -webkit-transform-style: flat;
    // -webkit-transition: 0.1s;
    top: 0;
    left: 0;
    width: 100%;
  }
  .front {
    // transform: rotateY(0deg);
    // -webkit-transform:rotateY(0deg);
    position: absolute;
  }
  .back {
    // transform: rotateY(-180deg);
    // -webkit-transform:rotateY(-180deg);
    position: absolute;
  }
  .flip-container.flipped .back {
    // transform: rotateY(0deg);
    // -webkit-transform:rotateY(0deg);
    visibility: visible;
  }
  .flip-container .back {
    // transform: rotateY(0deg);
    // -webkit-transform:rotateY(0deg);
    visibility: hidden;
  }
  .flip-container.flipped .front {
    // transform: rotateY(180deg);
    // -webkit-transform:rotateY(180deg);
    visibility: hidden;
  }
  .flip-container .front {
    // transform: rotateY(180deg);
    // -webkit-transform:rotateY(180deg);
    visibility: visible;
  }
  .front {
    z-index: 2;
  }
</style>

